import Vue from 'vue';
import { LAYERS } from '@/constants/gmaps.js';
import _ from 'lodash';

const SET_LAYERS = (state, layers) => {
  Object.keys(layers).forEach((key) => {
    let layer = layers[key];
    if (!state.layers[key]) {
      Vue.set(state.layers, layer.id, layer);
    }
  });
};

const SET_SUBLAYERS = (state, subLayers) => {
  // Sort sublayers by Sort Num
  let sortedSubLayers = _.orderBy(subLayers, ['sortNum'], ['asc']);

  // Iterate over and save to STORE
  Object.keys(sortedSubLayers).forEach((key) => {
    let subLayer = sortedSubLayers[key];
    if (!state.subLayers[subLayer.parentId]) {
      Vue.set(state.subLayers, subLayer.parentId, []); // Initate not exiting parent (layer) node
    }
    if (_.indexOf(state.subLayers[subLayer.parentId], subLayer.id) === -1) {
      state.subLayers[subLayer.parentId].push(subLayer.id);
    }
  });
};

const SET_ACTIVE_LAYERS_ON_INIT = (state, activeLayers) => {
  state.activeLayersOnInit = activeLayers;
};

const ADD_GM_LAYER = (state, { gmlayer, layerId }) => {
  let defaultOpacity = 100;
  if (state.layers[layerId].type === 'SVG') {
    defaultOpacity = 1;
  }

  Vue.set(state.layers[layerId], `gm`, gmlayer);
  Vue.set(state.layers[layerId], `isActive`, false);
  Vue.set(state.layers[layerId], `hold`, null);
  Vue.set(state.layers[layerId], `activeSublayersCounter`, 0);
  Vue.set(state.layers[layerId], `pinLayerOpen`, null); // Used to open <details> when pin is clicked
  Vue.set(state.layers[layerId], `opacity`, defaultOpacity); // Used to set the slider input
  //}
};

const TOGGLE_GM_LAYER = (state, { layerId, map }) => {
  let curLayer = state.layers[layerId];
  let parentLayer = null;

  if (curLayer.parentId) {
    parentLayer = state.layers[curLayer.parentId]; // get parent layer
  }

  if (curLayer.isActive) {
    curLayer.gm.setMap(null);
    curLayer.isActive = false;

    if (parentLayer) parentLayer.activeSublayersCounter--;
  } else {
    curLayer.gm.setMap(map);
    if (curLayer.opacity == 0 && curLayer.type == 'KML') {
      curLayer.gm.setMap(null);
    }
    curLayer.isActive = 1;
    curLayer.hold = 1;
    if (parentLayer) parentLayer.activeSublayersCounter++;
  }
};

const DISABLE_GM_LAYER = (state, { layerId, map }) => {
  let curLayer = state.layers[layerId];
  let parentLayer = null;

  if (curLayer.parentId) {
    parentLayer = state.layers[curLayer.parentId]; // get parent layer
  }

  curLayer.gm.setMap(null);
  curLayer.isActive = false;

  if (parentLayer) parentLayer.activeSublayersCounter--;
};

const CHANGE_SVG_OPACITY = (state, [layerId, opacity]) => {
  let curLayer = state.layers[layerId];
  curLayer.gm.setOpacity(opacity);

  curLayer.opacity = opacity;
};

const CHANGE_KML_OPACITY = (state, [layerId, opacity, map]) => {
  let curLayer = state.layers[layerId];

  if (opacity == 100) {
    curLayer.gm.setUrl(
      LAYERS.baseUrl + curLayer.phaseId + '/' + curLayer.mapUrl100
    );
    curLayer.gm.setMap(map);
  } else if (opacity == 50) {
    curLayer.gm.setUrl(
      LAYERS.baseUrl + curLayer.phaseId + '/' + curLayer.mapUrl50
    );
    curLayer.gm.setMap(map);
  } else {
    curLayer.gm.setMap(null);
  }
  curLayer.opacity = opacity;
};

const LOG_FETCHED_PHASE_LAYERS = (state, phaseId) => {
  state.fetchedLayersFromPhase.push(phaseId);
};

export default {
  SET_LAYERS,
  SET_SUBLAYERS,
  SET_ACTIVE_LAYERS_ON_INIT,
  ADD_GM_LAYER,
  TOGGLE_GM_LAYER,
  DISABLE_GM_LAYER,
  CHANGE_SVG_OPACITY,
  CHANGE_KML_OPACITY,
  LOG_FETCHED_PHASE_LAYERS
};
